// @flow

import * as React from "react";
import cx from "classnames";
import styles from "./PickerNav.scss";

type PickerNavProps = {
  label: string | number,
  setPrevious: () => void,
  setNext: () => void,
  isPreviousArrowSelectable: () => boolean,
  isNextArrowSelectable: () => boolean,
  ariaLabelPrevious: string,
  ariaLabelNext: string
};

const PickerNav = ({
  label,
  setPrevious,
  setNext,
  isPreviousArrowSelectable,
  isNextArrowSelectable,
  ariaLabelPrevious,
  ariaLabelNext
}: PickerNavProps) => (
  <div className={styles.yearNav}>
    <button
      type="button"
      className={cx(styles.arrow, {
        [styles.disabledArrow]: !isPreviousArrowSelectable
      })}
      onClick={isPreviousArrowSelectable ? setPrevious : undefined}
      aria-label={ariaLabelPrevious}
      data-testid="previousArrow"
    >
      {"<"}
    </button>
    <div className={styles.year}>{label}</div>
    <button
      type="button"
      className={cx(styles.arrow, {
        [styles.disabledArrow]: !isNextArrowSelectable
      })}
      onClick={isNextArrowSelectable ? setNext : undefined}
      aria-label={ariaLabelNext}
      data-testid="nextArrow"
    >
      {">"}
    </button>
  </div>
);

PickerNav.propTypes = {};

export default PickerNav;
